/*
 *  Author: Raul Perusquia <raul@inikoo.com>
 *  Created: Thu, 25 Aug 2022 00:33:39 Malaysia Time, Kuala Lumpur, Malaysia
 *  Copyright (c) 2022, Raul A Perusquia F
 */
// import { Navigation, grpNavigation, orgNavigation } from "@/types/Navigation"
// import { useColorTheme } from '@/Composables/useStockList'


import { defineStore } from "pinia"
import { Image } from "@/types/Image"
import { Colors } from "@/types/Color"
// import { OrganisationsData, Group, OrganisationState, StackedComponent} from '@/types/LayoutRules'


export const useLayoutStore = defineStore("layout", {
    state: () => (
        {
            app: {
                color: null as unknown | Colors,  // Styling layout color
                theme: ['#67e8f9', '#1f1f1f', '#005a9c', '#fff', '#67e8f9', '#005a9c', '#fcd34d', '#374151'] as string[],  // For styling app color
                environment: null as string | null // 'local' | 'staging'
            },
            currentRoute: "grp.dashboard.show", // Define value to avoid route null at first load
            currentParams: {} as {[key: string]: string},
            leftSidebar: {
                show: true,
            },
            rightSidebar: {
                activeUsers: {
                    users: [],
                    count: 0,
                    show: false
                },
            },
            // stackedComponents: [] as StackedComponent[],
            user: {} as { id: number, avatar_thumbnail: Image, email: string, username: string },
        }
    ),

});

